import React from 'react';

import { FirstStripCheckout, LogoIcon, PadLockIcon, SecondStripCheckout } from './style';

import WhitePadlockIconSVG from '../../../assets/images/headerCheckout/white-padlock-icon.svg';
import LogoResolvaIconSVG from '../../../assets/images/headerCheckout/logo-resolva-icon.svg';

export default function CheckoutHeader(): JSX.Element {
  return (
    <>
      <FirstStripCheckout>
        <PadLockIcon src={WhitePadlockIconSVG} alt="Ícone de cadeado" />
        <span>COMPRA 100% SEGURA</span>
      </FirstStripCheckout>
      <SecondStripCheckout>
        <LogoIcon src={LogoResolvaIconSVG} alt="Logo do Resolva" />
        <p>CHECKOUT DO RESOLVA</p>
      </SecondStripCheckout>
    </>
  );
}
